import { render } from "./DownloadUnlockDialog.vue?vue&type=template&id=822d49ba&scoped=true"
import script from "./DownloadUnlockDialog.vue?vue&type=script&lang=js"
export * from "./DownloadUnlockDialog.vue?vue&type=script&lang=js"

import "./DownloadUnlockDialog.vue?vue&type=style&index=0&id=822d49ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-822d49ba"]])

export default __exports__